import {TaskAddForm, TaskEditForm} from './screens';

const stackRoutes = [
  {
    name: 'task-add',
    component: TaskAddForm,
  },
  {
    name: 'task-edit',
    component: TaskEditForm,
  },
];

export default {
  stack: stackRoutes,
};
